module.exports = __webpack_public_path__ + "faSawBottom.png?06676e5e6fcb8356325b2bed5ea1fd4e";